import { makeStyles } from 'tss-react/mui';

const POPOVER_TAB_MAX_WIDTH = 280;

export const usePopoverTabsStyles = makeStyles()((theme) => ({
  root: {
    minWidth: 0,
    backgroundColor: theme.palette.background.default,
    borderRadius: theme.shape.borderRadiusFull,
    padding: theme.spacing(0.5),
    '& .MuiTabs-root': {
      minHeight: 'auto',
    },
    '& .MuiTabs-indicator': {
      display: 'none',
    },
    '& .MuiTabs-flexContainer': {
      gap: theme.spacing(0.5),
    },
    '& .MuiTab-root': {
      minWidth: 0,
      flexShrink: 1,
      maxWidth: POPOVER_TAB_MAX_WIDTH,
      minHeight: 26,
      borderRadius: theme.shape.borderRadiusFull,
      padding: theme.spacing(0.5, 1.5),
      textTransform: 'none',
      overflow: 'hidden',
      fontFamily: theme.typography.body2.fontFamily,
      fontSize: theme.typography.body2.fontSize,
      fontWeight: theme.typography.fontWeightMedium,
      lineHeight: theme.typography.body2.lineHeight,
      letterSpacing: theme.typography.body2.letterSpacing,
      color: theme.palette.text.secondary,
      transition: theme.transitions.create(['background-color', 'color'], {
        duration: theme.transitions.duration.shorter,
      }),
      '&:hover': {
        color: theme.palette.text.primary,
      },
    },
    '& .MuiTab-root.Mui-selected': {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.action.selected,
    },
  },
}));
